import { render, staticRenderFns } from "./Office365BackupWizard.vue?vue&type=template&id=84583180&"
import script from "./Office365BackupWizard.vue?vue&type=script&lang=js&"
export * from "./Office365BackupWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports